<div class="explore">
  <div class="explore__title" *ngIf="selectedCategory$ | async">
    {{ (selectedCategory$ | async)?.title }}
  </div>

  <div class="explore__header">
    <app-bookmarks-sort
      class="mr-4"
      (sort)="handleBookmarksSort($event)"
      [selection]="sort$ | async">
    </app-bookmarks-sort>

    <app-gallery-view-mode></app-gallery-view-mode>
  </div>

  <div class="explore__results">
    <app-gallery-results
      [loading]="loading$ | async"
      [results]="searchResults$ | async" 
      [checkable]="false"
      (selectBookmark)="handleSelectBookmark($event)"
      [showActions]="true"
      [viewMode]="viewMode$ | async"
      selectLabel="View"
      *ngIf="searchResults$ | async">
      <ng-template #galleryActions let-item>
        <app-bookmark-actions
            theme="light"
            [bookmark]="item" 
            [bookmarkType]="item.type"
            [bookmarkEmbedTypes]="['bookmark', 'module']"
            [bookmarkActions]="bookmarkActions">
        </app-bookmark-actions>
      </ng-template>

      <ng-template #galleryTags let-item>
          <app-list listType="commafied">
            <!-- Premium -->
            <app-list-item *ngIf="item.premium && !(isPremiumUser$ | async)">
              <fa-icon icon="lock"></fa-icon> Premium
            </app-list-item>

            <!-- Animated -->
            <app-list-item *ngIf="item.animated">
              Animated
            </app-list-item>

            <!-- Tour -->
            <app-list-item *ngIf="item.tour">Tour</app-list-item>
          </app-list>
      </ng-template>
    </app-gallery-results>
  </div>
</div>